// extracted by mini-css-extract-plugin
export default {"tabs":"SecondaryTabsBar-module__tabs__6LfYt","tabsContainer":"SecondaryTabsBar-module__tabsContainer__jiGFy","indicator":"SecondaryTabsBar-module__indicator__kux7X"};